import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_service_masters`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function list_service_by_category(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_service_masters?filter[service_master_category_id]=${params}`, options)
  .then(response => {
    let service_master = jsona.deserialize(response.data);
    delete service_master.links;
    return service_master;
  });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_service_masters/${id}`, options)
    .then(response => {
      let service_master = jsona.deserialize(response.data);
      delete service_master.links;
      return service_master;
    });
}

function add(service_master) {
  
  console.log(service_master);
  const payload = jsona.serialize({
    stuff: service_master,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_service_masters`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(service_master) {
  const payload = jsona.serialize({
    stuff: service_master,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_service_masters/${service_master.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_service_masters/${id}`, options);
}


export default {
  list,
  list_service_by_category,
  get,
  add,
  update,
  destroy
};

